import { Card } from "@scuf/common";
import { Chart } from "@scuf/charts";
import React, { useEffect, useState } from "react";
import { getValoresPeriodo } from "../../../services/services";
import formatDate from "../../../utils/formatDate";
import { plotBackground } from "../../../config/colors";
import { chartLineColor } from "../../../config/colors";

export default function PerfilAlimentacionTostador() {
  // Objeto inicial de la peticion
  const initialFetch = {
    idSeccion: 4,
    secuencia: 47,
    ultimo: 0,
    frecuencia: 5,
    dias: 7,
  };

  const defaultObject = Object.assign({
    value: [],
    fecha: [],
  });

  // Fecha inicial y final
  const [date, setDate] = useState({ start: "19-01-2023", end: "25-01-2023" });

  const [flujoSiliceTostador, setFlujoSiliceTostador] = useState(defaultObject);
  const [flujoConcentradoTostador, setFlujoConcentradoTostador] =
    useState(defaultObject);
  const [nivelFeedbin, setNivelFeedbin] = useState(defaultObject);
  const [flujoFeedbin, setFlujoFeedbin] = useState(defaultObject);
  const [flujoConcentradoSecoTostador, setFlujoConcentradoSecoTostador] =
    useState(defaultObject);

  useEffect(() => {
    // Peticion de datos al API
    async function fetchData() {
      // Solo nos traemos la data de la peticion
      const { data } = await getValoresPeriodo(initialFetch);

      populateFlujoSiliceTostador(data);
      populateConcentradoTostador(data);
      populateNivelFeedbin(data);
      populateFlujoFeedbin(data);
      populateFlujoConcentradoSeco(data);
      //#endregion
    }

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function populateFlujoSiliceTostador(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Flujo de Sílice a Tostador"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setFlujoSiliceTostador({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateConcentradoTostador(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Flujo de Concentrado a Tostador"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setFlujoConcentradoTostador({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateNivelFeedbin(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Nivel del Feedbin"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setNivelFeedbin({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateFlujoFeedbin(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Flujo del Feedbin"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setFlujoFeedbin({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateFlujoConcentradoSeco(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Flujo Concentrado Seco a Tostador"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setFlujoConcentradoSecoTostador({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  return (
    <>
      <Card>
        <Card.Content>
          <Chart
            plotBackgroundColor={plotBackground}
            title={"Perfil Alimentación Tostador"}
            subtitle={"Periodo " + date.start + " - " + date.end}
            showRangeSelector={true}
          >
            {/** -------------------------------- Flujo de Sílice a Tostador --------------------------------------- */}
            <Chart.Line
              name="Flujo de Sílice a Tostador"
              data={flujoSiliceTostador.value}
              yAxis={0}
            />

            {/** -------------------------------- Flujo de Concentrado a Tostador --------------------------------------- */}
            <Chart.Line
              name="Flujo de Concentrado a Tostador"
              data={flujoConcentradoTostador.value}
              yAxis={0}
            />

            {/** -------------------------------- Nivel del Feedbin --------------------------------------- */}
            <Chart.Line
              name="Nivel del Feedbin"
              data={nivelFeedbin.value}
              yAxis={1}
            />

            {/** -------------------------------- Flujo del Feedbin --------------------------------------- */}
            <Chart.Line
              name="Flujo del Feedbin"
              data={flujoFeedbin.value}
              yAxis={0}
            />

            {/** -------------------------------- Flujo Concentrado Seco a Tostador --------------------------------------- */}
            <Chart.Line
              name="Flujo Concentrado Seco a Tostador"
              data={flujoConcentradoSecoTostador.value}
              yAxis={0}
            />

            {/** -------------------------------- FECHAS --------------------------------------- */}
            <Chart.XAxis categories={flujoSiliceTostador.fecha} />

            <Chart.YAxis
              labelSuffix=" t/h"
              title="flujo masico"
              lineWidth={2}
              lineColor="white"
              min={0}
              max={120}
            />

            <Chart.YAxis
              labelSuffix=" %"
              title="nivel de feedbin"
              lineWidth={2}
              lineColor="white"
              opposite={true}
              min={0}
              max={100}
            />

            <Chart.Tooltip valueSuffix=" Nm3/t" />
          </Chart>
        </Card.Content>
      </Card>
    </>
  );
}
